import React from 'react';
import {ButtonBar, AddButton} from '../commons/Forms.js';
import ReactSpinner from 'react-spinjs';
import {connect} from 'react-redux';
import {fetchGroomersForSkiresort} from '../../redux/groomers/actions';
import {Status, NEW_ELEMENT_ID} from '../../redux/_commons/const';
import {Pane, Part} from '../commons/Panes';
import GroomerEditionForm from './GroomerEditionForm';
import { showPhone } from '../../utils';

import '../../styles/adminPanels.less';


/** Affiche la liste des dameuses de la station */
@connect(
  state => ({groomers: state.groomers, user: state.user}),
  {fetchGroomersForSkiresort}
)
export default class GroomersEdit extends React.Component {

  constructor() {
    super();
    this.state = {
      selectedGroomerId: null
    }
  }

  /** Retourne la liste des dameuses (ou un status Echec/Chargement) de la station en cours */
  getItems() {
    const groomers = this.props.groomers;

    if (!groomers || groomers.items === undefined || groomers.status === Status.LOADING) {
      return Status.LOADING;
    } else if (groomers.status === Status.FAILURE) {
      return Status.FAILURE;
    } else {
      return groomers.items.filter(i => i.ski_resort_id === this.props.user.selectedSkiresort.id);
    }
  }


  getTitle() {
    const content = this.getItems();
    let count = '...';
    if (Status.isAvailable(content)) {
      count = content.size;
    }

    return `Dameuses (${count})`;
  }

  getContent() {
    const groomers = this.getItems();
    const onSelect = (groomer) => this.setState({selectedGroomerId: groomer.id});
    const {selectedGroomerId} = this.state;

    if (!Status.isLoaded(groomers)) {
      return <ReactSpinner/>;
    } else if (!Status.isAvailable(groomers)) {
      return (<div className='err'> Une erreur a eu lieu</div>);
    } else {
      return (
        <div>
          {groomers.sortBy(g => (typeof g.code === "string" ? g.code.toLowerCase() : g.code)).valueSeq().toJS().map(
            item => <GroomerItem key={item.id} item={item} onSelect={onSelect}
                                 selected={selectedGroomerId !== null && selectedGroomerId === item.id}/>)}
        </div>
      );
    }
  }

  /** Mise a jour dans le cas de la suppression de la dameuse sélectionnée */
  componentWillReceiveProps(nextProps) {
    const {groomers} = nextProps;
    if (!groomers.items.has(this.state.selectedGroomerId)) {
      this.setState({selectedGroomerId: null});
    }
  }


  render() {
    const {selectedGroomerId} = this.state;
    const {inProgress} = this.props.groomers;

    return (
      <div>
        <Pane title="Liste des dameuses">
          <Part title={ this.getTitle() }>
            <div style={{minHeight: 200, position: 'relative'}}>
              { this.getContent() }
            </div>

            <ButtonBar>
              <AddButton onClick={() => this.setState({selectedGroomerId: NEW_ELEMENT_ID})}/>
            </ButtonBar>
          </Part>
        </Pane>
        {selectedGroomerId !== null ?
          <GroomerEditionForm
            groomer={selectedGroomerId === NEW_ELEMENT_ID ? {id: NEW_ELEMENT_ID} : this.props.groomers.items.get(selectedGroomerId)}
            inProgress={inProgress.includes(selectedGroomerId)}
            onCancel={() => this.setState({selectedGroomerId: null})}/>
          : null}
      </div>
    )
  }
}


/**
 * Composant qui affiche une dameuse dans la liste
 */
let GroomerItem = ({item, onSelect, selected}) => {
  return (
    <div className={['groomer-item', selected ? 'selected' : null].join(' ')}
         onClick={() => onSelect(item)}>
      <i style={{float: 'left'}} className="mi mi-chevron-left"/>
      <span>{item.code} ({showPhone(item.phone)})</span>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/admin/GroomersEdit.js